<!-- breadcrumb start
<div class="breadcrumb-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-6">
        <div class="page-title">
          <h2>{{ 'cart' | translate  }}</h2>
        </div>
      </div>
      <div class="col-sm-6">
        <nav aria-label="breadcrumb" class="theme-breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="'/home'">{{ 'home' | translate  }}</a></li>
            <li class="breadcrumb-item active">{{ 'cart' | translate  }}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</div>
breadcrumb End -->
<!-- section start -->
<section class="cart-section section-b-space">
  <div class="container">
    <mat-card class="margin-card">
      <h3 class="title-invoice">{{ "cart" | translate }}</h3>

      <!-- Loading state -->
      <div class="col-sm-12 text-center" *ngIf="isLoading" style="padding: 50px 0;">
        <mat-spinner style="margin: 0 auto;"></mat-spinner>
        <p style="margin-top: 20px;">{{ "loading" | translate }}...</p>
      </div>

      <!-- Empty cart message -->
      <div class="col-sm-12 empty-cart-cls text-center" *ngIf="!isLoading && !shoppingCartItems.length">
        <span class="material-icons">
          shopping_cart
        </span>
        <h3>
          <strong>{{ "cart-empty" | translate }}</strong>
        </h3>
      </div>
      <div *ngIf="!isLoading && shoppingCartItems.length" class="cart-table">
        <div class="row hidden-md cart-header">
          <div class="col-1"></div>
          <div class="col-2">{{ "cart-table.image" | translate }}</div>
          <div class="col-2">{{ "cart-table.product-name" | translate }}</div>
          <div class="col-2">{{ "cart-table.price" | translate }}</div>
          <div class="col-3">{{ "cart-table.quantity" | translate }}</div>
          <div class="col-2">{{ "cart-table.total" | translate }}</div>
        </div>

        <div *ngFor="let item of shoppingCartItems">
          <div class="row cart-contenido align-items-center">
            <div class="col-1 col-md-1 cart-text">
              <h2>
                <a [routerLink]="" (click)="removeItem(item)">
                  <mat-icon color="primary">delete</mat-icon>
                </a>
              </h2>
            </div>

            <div class="col-md-2 hidden-md"> <a [routerLink]="[
                        '/home/left-sidebar/product',
                        item.product?.sku
                      ]">
                <img [src]="getUrl(item.product?.photos)" alt="" />
              </a></div>
            <div class="col-4 col-sm-5 col-md-4 col-lg-2 cart-text"> <a [routerLink]="[
                '/home/left-sidebar/product',
                item.product?.sku
              ]">{{ item.product?.name }}</a></div>
            <div class="col-md-2 cart-text hidden-md">
              <h4>$ {{ getPrice(item.product) }}</h4>
            </div>
            <div class="col-6 col-sm-3 col-md-3">
              <div class="qty-box">
                <div class="input-group">
                  <span class="input-group-prepend">
                    <button type="button" class="btn quantity-left-minus" (click)="decrement(item.product)"
                      data-type="minus" data-field="">
                      -
                    </button>
                  </span>
                  <input type="text" name="quantity" class="form-control input-number"
                    [(ngModel)]="item.quantity" (focusout)="update(item)"  maxlength="3"/>
                  <span class="input-group-prepend">
                    <button type="button" class="btn quantity-right-plus" (click)="increment(item.product)"
                      data-type="plus" data-field="">
                      +
                    </button>
                  </span>
                </div>
              </div>
            </div>

            <div class="col-6 offset-6 col-sm-3 offset-sm-0 col-md-3 offset-md-0 col-lg-2 cart-text margen-top-mobile">
              <h4>$ {{ getSubtotal(item) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="!isLoading && shoppingCartItems.length">
        <div
          class="col-6 col-sm-3 offset-sm-6 col-md-3 offset-md-6 col-lg-2 offset-lg-7 col-xl-2 offset-xl-8 cart-table">
          {{ "cart-table.total-price" | translate }} :
        </div>
        <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-2 cart-table">
          <h2>$ {{ getTotal() | async }}</h2>
        </div>
      </div>
      <div class="row cart-buttons" *ngIf="!isLoading && shoppingCartItems.length">
        <div>
          <button [routerLink]="['/home']" mat-stroked-button color="primary">
            {{ "cart-table.continue-shopping" | translate }}
          </button>
        </div>
        <div>
          <button [routerLink]="['/home/checkout']" mat-raised-button color="primary">
            {{ "cart-table.check-out" | translate }}
          </button>
        </div>
      </div>


    </mat-card>
  </div>
</section>
